import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';

const CHILD_NAV_ITEMS = [
  { path: '/child', icon: '🏠', label: 'Home' },
  { path: '/child/permissions', icon: '🛡️', label: 'Privacy' },
  { path: '/child/chat', icon: '💬', label: 'Chat' },
  { path: '/child/help', icon: '🤖', label: 'Guide' },
  { path: '/child/settings', icon: '⚙️', label: 'Settings' },
];

export default function ChildBottomNav() {
  const navigate = useNavigate();
  const location = useLocation();

  return (
    <nav className="instagram-bottom-nav child-bottom-nav">
      {CHILD_NAV_ITEMS.map((item) => {
        const isActive = location.pathname === item.path;
        return (
          <button
            key={item.path}
            className={`instagram-nav-item ${isActive ? 'active' : ''}`}
            onClick={() => navigate(item.path)}
            title={item.label}
          >
            <span className="nav-icon">{item.icon}</span>
            <span className="nav-label">{item.label}</span>
          </button>
        );
      })}

      <style>{`
        .child-bottom-nav {
          display: none;
        }

        @media (max-width: 768px) {
          .child-bottom-nav {
            display: flex;
          }
        }
      `}</style>
    </nav>
  );
}
